// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HowItem_wrapper__zN3XV","step":"HowItem_step__AxUNn","title":"HowItem_title__CCm4d"};